import Sponsers from "./Sponsers"
import {Usedata} from "./Context/Allcontext"
import { Link } from "react-router-dom"
function Homepage(){
    const {ActiveSako , ActiveAlert} = Usedata()
    return(
        <div className="homepage">
        <div className="qayb qoraal">
            <span className="qote">
                <p>#1 Shabakadii Ugu Horaysay guud ahaan gayiga soomalida</p>
            </span>
            <h2>Waa shabakada loogu tallo galay xisabinta sakada si waafaqsan Shareecada</h2>
            {/* saponser */}
            <Sponsers />
            <div className="btn_and_link">
                <button onClick={ActiveSako}><i className="fa-solid fa-calculator"></i> Xisaabi Sako</button>
                <Link to="/">
                <button onClick={ActiveAlert} className="dhaxal"> <i className="fa-solid fa-circle-dollar-to-slot"></i> Xisaabi Dhaxal </button>
                </Link>
            </div>
        </div>
        <div className="qayb _sawir_mobile">
            <img src="/images/Home04.svg" alt="ss" />
        </div>
    </div>
    )
}


export default Homepage